import { usersRepo } from '@/constants/providers';
import { ApiResponse } from '@/shared/types';
import { useMutation } from '@tanstack/react-query';
import { LastHourlyRateJson } from '../types';

export const useUpdateLastActiveHourlyRate = () =>
  useMutation<ApiResponse<unknown>, unknown, LastHourlyRateJson>((hourRate) =>
    usersRepo.updateLastHourlyRate(hourRate),
  );
